import { VenueVideoBoardsService } from './venue-video-boards.service';
import { ChangeDetectionStrategy, Component, computed, inject, OnDestroy } from '@angular/core';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'app-venue-video-boards',
  templateUrl: './venue-video-boards.component.html',
  styleUrls: ['./venue-video-boards.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IonicModule
  ]
})
export class VenueVideoBoardsComponent implements OnDestroy {
  private venueVideoBoardService = inject(VenueVideoBoardsService);

  videoBoards = computed(() => this.venueVideoBoardService.videoBoards());
  loaded = computed(() => !!this.videoBoards())


  constructor() { }

  ngOnDestroy() {}
}
